import Vue from 'vue'

const Pages = {
  namespaced: true,

  state: {
    page: {},
    pageTitle: null,
    pages: []
  },

  mutations: {
    setPages(state, pages) {
      state.pages = pages || []
    },
    setPage(state, page) {
      state.page = page || {}
      state.pageTitle = state.page.title
    }
  },

  actions: {
    async getAll({ commit }, { search } = {}) {
      const params = { search }
      const response = await Vue.axios.get('/pages', { params })
      const pages = response.data.data
      commit('setPages', pages)
      return pages
    },
    async get({ commit }, id) {
      let page = {}
      if (id) {
        const response = await Vue.axios.get(`/page/${id}`)
        page = response.data.data
      }
      commit('setPage', page)
      return page
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.page.id) {
        response = await Vue.axios.put(`/page/${state.page.id}`, state.page)
      } else {
        response = await Vue.axios.post('/page', state.page)
      }
      commit('setPage', response.data.data)
    },
    async updatePageProductRank({ state }, { productId, rank }) {
      await Vue.axios.put(`/page/${state.page.id}/product/${productId}/rank`, { rank })
    }
  }
}

export default Pages
